module.exports = __webpack_public_path__ + "img/formulary.f146307e.png";